<div *ngIf="displaySummary; else show_full">
    <p *ngIf="noSlots">No availability specified.</p>
    <p *ngIf="availableCount > 0">Available slots: {{availableCount}} of {{totalCount}} ({{percentAvailable}}%)</p>
</div>
<ng-template #show_full>
    <p *ngIf="noSlots" class="alert alert-danger">No availability specified</p>
    <app-time-slot *ngIf="days" [days]="days" [canEdit]="false" (itemSelected)="timeSlotSelected($event)"></app-time-slot>
</ng-template>